<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div class="title-letter" fxLayout="row" fxLayoutGap="10px">
        <mat-icon>edit</mat-icon>
        <span>{{ title }}</span>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="addStringMessages()" [disabled]="!stringMessagesFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span>{{'更新' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content fxFlex="600px" style="overflow: auto;">
    <form [formGroup]="stringMessagesFormGroup">
      <div fxLayout="column" fxLayoutGap="10px">
        <mat-checkbox (change)="onChangeAutoAllTrans()" formControlName="autoAllTrans" color="primary">{{'全言語自動翻訳' | translate}}</mat-checkbox>

        <div *ngIf="!!stringMessagesArrayControl" formArrayName="stringMessages" fxFlex="100%">
          <table>
              <tr *ngFor="let stringMessagesForm of stringMessagesArrayControl.controls; let i=index" [formGroupName]="i">
                <td>
                  <p fxFlex="100%">
                    {{ currentLang == 'en' ? (projectLanguages[i].lang_name_en ? projectLanguages[i].lang_name_en : (projectLanguages[i].lang_name | translate)):  projectLanguages[i].lang_name }}&nbsp;&nbsp;&nbsp;&nbsp;
                    <mat-checkbox *ngIf="i !== 0" (change)="onChangeAutoTrans()" formControlName="autoTrans" color="primary">{{'自動翻訳' | translate}}</mat-checkbox>
                  </p>
                </td>
                <td>
                  <mat-form-field fxFlex="100%">
                    <input matInput formControlName="stringMessage">
                  </mat-form-field>
                </td>
                <td *ngIf="i === 0"><p fxFlex="100%">{{'翻訳用' | translate}}（{{ currentLang == 'en' ? (projectLanguages[i].lang_name_en ? projectLanguages[i].lang_name_en : (projectLanguages[i].lang_name | translate)):  projectLanguages[i].lang_name }}）</p></td>
                <td *ngIf="i === 0">
                  <mat-form-field fxFlex="100%">
                    <input matInput formControlName="transStringMessage">
                  </mat-form-field>
                </td>
              </tr>
          </table>
        </div>
      </div>
    </form>
  </div>


</div>
